import React from 'react';
import { Container, Typography, Box, Grid, Paper, Link as MuiLink } from '@mui/material';
import CustomTypography from './UI/Typography/CustomTypography';

const synergiesData = [
  {
    combined: true,
    items: [
      {
        image: `${process.env.PUBLIC_URL}/images/synergies/Picture1.png`,
        title: 'EU Protective Security Advisors (EU PSA)',
        description: (
          <>
            <Typography variant="body1" style={{ lineHeight: '1.6', marginBottom: '10px' }}>
              The Counter-Terrorism Agenda, presented by the Commission on 9 December 2020, is a well-rounded package of several legislative proposals for the EU to fight terrorism in the future. The proposed rules are set across four pillars:
            </Typography>
            <ul style={{ margin: 0, paddingLeft: '20px', marginBottom: '10px' }}>
              <li><b>Anticipate</b></li>
              <li><b>Prevent</b></li>
              <li><b>Protect</b></li>
              <li><b>Respond</b></li>
            </ul>
          </>
        ),
        link: 'https://home-affairs.ec.europa.eu/policies/internal-security/counter-terrorism-and-radicalisation/protection/eu-protective-security-advisors-eu-psa_en',
        linkLabel: 'Learn more',
      },
      {
        image: `${process.env.PUBLIC_URL}/images/synergies/Picture2.png`,
        title: 'Anticipate Pillar & PSA Initiative',
        description: (
          <>
            <Typography variant="body1" style={{ lineHeight: '1.6', marginBottom: '10px' }}>
              As part of the Anticipate Pillar, among the initiatives proposed is also the new tool to support EU countries with advice on the vulnerabilities of public spaces - the EU Protective Security Advisors (PSA).
            </Typography>
            <Typography variant="body1" style={{ lineHeight: '1.6', marginBottom: '10px' }}>
              The initiative began by EU countries inviting the Commission to support with vulnerability assessments during high-risk events and at critical infrastructures. After positive progress, security authorities in EU countries sponsored the idea to create a permanent EU pool of experts to support future PSA missions.
            </Typography>
          </>
        ),
        link: 'https://home-affairs.ec.europa.eu/policies/internal-security/counter-terrorism-and-radicalisation/protection/eu-protective-security-advisors-eu-psa_en',
        linkLabel: 'Learn more',
      },
    ],
  },
  {
    image: `${process.env.PUBLIC_URL}/images/synergies/Picture4.png`,
    title: 'HRSN- High Risk Security Network',
    description: (
      <>
        <Typography variant="body1" style={{ lineHeight: '1.6', marginBottom: '10px' }}>
          The main goal of the HRSN is to improve the safety and security in public spaces, once we've learned that past protective approaches are not enough, aware of the intrinsic vulnerabilities of these so-called "soft targets" that result from their open nature and public character, as well as the involvement of a high-volume number of assistants that can be potential victims of this new type of criminal and terror acts. The network aims to keep the openness and inclusiveness nature of European public spaces without resembling fortified, avoiding to constrain their daily use for social interaction and collective living, reducing vulnerabilities, mitigating the consequences of attacks and improving cooperation among responders.
        </Typography>
        <Typography variant="body1" style={{ lineHeight: '1.6', marginBottom: '10px' }}>
          As mentioned in the Public Spaces Protection Plan, High Risk Security Network brings together representatives of specialized law enforcement units responsible for the protection of high risk public spaces, providing a platform for common training and joint exercises, in order to support Member States in improving their preparedness against current and future threats and enhancing their capacity to react in case of an attack.
        </Typography>
        <Typography variant="body1" style={{ lineHeight: '1.6', marginBottom: '10px' }}>
          The Network is a branch of the Migration and Home Affairs (DG-HOME) and it is financed with the Internal Security Funds (ISF), composed by 28 members (units/institutions), from 21 countries: Austria, Belgium, Bulgaria, Cyprus, Chez Republic, Denmark, Estonia, France, Germany, Greece, Hungary, Ireland, Italy, Latvia, Lithuania, Malta, Poland, Portugal, Romania, Spain, and The Netherlands. As associated members, with the status of observers, it counts with additional partners, from Norway, Slovakia, United Kingdom, United Stated of America, Ghana, Kenya and Senegal, as well as Atlas network and DG HOME D2. CT Unit.
        </Typography>
      </>
    ),
    link: 'https://hrsn.eu/',
    linkLabel: 'Learn more',
  },
  {
    image: `${process.env.PUBLIC_URL}/images/synergies/Picture3.png`,
    title: 'Joint Research Centre (JRC)',
    description: (
      <>
        <Typography variant="body1" style={{ lineHeight: '1.6', marginBottom: '10px' }}>
          This department provides independent, evidence-based knowledge and science, supporting EU policies to positively impact society. 
        </Typography>
        <Typography variant="body1" style={{ lineHeight: '1.6', marginBottom: '10px' }}>
          Scientists at the Joint Research Centre (JRC) carry out research in various fields to provide independent advice to EU policymakers and put science at the heart of European policies. Originally established under the Euratom Treaty, the JRC has longstanding expertise in the nuclear field, but offers scientific competences from a wide range of disciplines to support almost all EU policy areas.
        </Typography>
        <Typography variant="body1" style={{ lineHeight: '1.6', marginBottom: '10px' }}>
          We work closely with research and policy organisations in EU countries, European institutions and agencies, and scientific partners in Europe and worldwide. Our core strengths are anticipation - providing the scientific underpinning for future policy initiatives; integration - linking scientific and policy areas as no single area can provide answers to today's complex challenges; and impact - assisting policymakers to track and assess the impact of their policies
        </Typography>
      </>
    ),
    link: 'https://joint-research-centre.ec.europa.eu/index_en',
    linkLabel: 'Learn more',
  },
  {
    image: `${process.env.PUBLIC_URL}/images/synergies/Picture5.png`,
    title: 'SPIRIT',
    description: (
      <>
        <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: '8px' }}>
          Synergies to protect places of worship and religious gatherings
        </Typography>
        <Typography variant="body1" style={{ lineHeight: '1.6', marginBottom: '10px' }}>
          <b>About the project</b><br/>
          SPIRIT will benefit law enforcement agencies, religious communities and individual religious sites' operators by improving their prevention / response effectiveness in a resource efficient and cost-effective manner.
        </Typography>
        <Typography variant="body1" style={{ lineHeight: '1.6', marginBottom: '10px' }}>
          <b>Impact and ambition</b><br/>
          SPIRIT objectives are generally based upon EU Action Plan to support the protection of Place of Worship, having specific outcomes that will include training courses, technology-aided training courses, audio-visual material, table-top exercises, awareness events. Standard Operating Procedures based on vulnerability assessments and best practices of previous response incidences will define stakeholders' operations and possible methods for emergency incidents.
        </Typography>
      </>
    ),
    link: 'https://spirit-isf.eu/project/',
    linkLabel: 'Learn more',
  },
  {
    image: `${process.env.PUBLIC_URL}/images/synergies/Picture6.png`,
    title: 'HOTHREAT',
    description: (
      <>
        <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: '8px' }}>
          Tailored CBRNe protection measures for hotels and conference centres
        </Typography>
        <Typography variant="body1" style={{ lineHeight: '1.6', marginBottom: '10px' }}>
          <b>Project concept</b><br/>
          HOTHREAT – Tailored CBRNe protection measures for hotels and conference centres.
        </Typography>
        <Typography variant="body1" style={{ lineHeight: '1.6', marginBottom: '10px' }}>
          The range of hotel services is becoming increasingly diverse and widespread around the world. People visit hotels not only for accommodation, but also for health-promoting services such as spas, wellness, swimming pools, golf pools and gyms and for conferences.
        </Typography>
        <Typography variant="body1" style={{ lineHeight: '1.6', marginBottom: '10px' }}>
          Hotels, cultural, leisure and entertainment facilities have been targets of terrorist attacks for long and the threat level is constantly increasing. Due to their characteristics, hotels rank high in vulnerability to such attacks. This is very well understood in many hotels and security of guests is well protected. However threats coming from the terrorist use of CBRN agents are considered as a new type of threat and preparedness and response to this type of attack need to be elevated.
        </Typography>
        <Typography variant="body1" style={{ lineHeight: '1.6', marginBottom: '10px' }}>
          For these reasons, we created a project that aims to create prevention, response and consequence management mechanisms and interoperable capabilities, recommendations for equipment and algorithms of cooperation with services in cases of CBRNe act in hotels and conference centres. The main objective of our project is to increase the safety of EU MS society using daily the services hotel and conference centres.
        </Typography>
        <Typography variant="body1" style={{ lineHeight: '1.6', marginBottom: '10px' }}>
          Our project's team is a group of comprehensively experienced specialists representing various fields of expertise who may share their experience and transmit professional knowledge of dealing with CBRNe risks to the hotels and conference centres. The project represents a novel concept of prevention against CBRNE threats, focused on specific areas which have not been prepared for this type of acts so far.
        </Typography>
      </>
    ),
    link: 'https://hothreat.eu/',
    linkLabel: 'Learn more',
  },
  {
    image: `${process.env.PUBLIC_URL}/images/synergies/Picture7.png`,
    title: 'ProSPeReS',
    description: (
      <>
        <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: '8px' }}>
          Protection System for large gatherings of people in Religious Sites
        </Typography>
        <Typography variant="body1" style={{ lineHeight: '1.6', marginBottom: '10px' }}>
          <b>Project concept</b><br/>
          Religious sites are considered to be especially vulnerable to attacks due to their accessibility and the fact that there are usually limited security measures applied.
        </Typography>
        <Typography variant="body1" style={{ lineHeight: '1.6', marginBottom: '10px' }}>
          ProSPeReS project is aimed at increasing the level of protection in places of worship with keeping the balance between security measures and preservation of the open nature of religious sites.
        </Typography>
        <Typography variant="body1" style={{ lineHeight: '1.6', marginBottom: '10px' }}>
          It will be achieved by forming a cooperation between faith-based leaders, public services and security experts, the places risk evaluation, raising public awareness (especially key beneficiaries – clergy and worshippers), as well as developing and validating comprehensive protection system.
        </Typography>
        <Typography variant="body1" style={{ lineHeight: '1.6', marginBottom: '10px' }}>
          The system involves tools and templates (i.e. including utilization of EU Vulnerability Assessment Tool), training (including eLearning with VR), educational materials and security precautions covering entire cycle of an emergency (from prevention to recovery), a model of security system for indoor and outdoor religious gatherings with set of recommendations. The model will include upmost effective ways of cooperation between public authorities and services, faith-based leaders, various religious institutions, security experts and practitioners. Efficient communication is a key element in order to build solid platform for exchanging needs, expectations, best practices; sharing knowledge and experiences on usage of technological and non-technological solutions as well as existing and potential innovations in the respected field.
        </Typography>
      </>
    ),
    link: 'https://prosperes.eu/',
    linkLabel: 'Learn more',
  },
  {
    image: `${process.env.PUBLIC_URL}/images/synergies/Picture8.png`,
    title: 'TRACY',
    description: (
      <>
        <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: '8px' }}>
          Data analytics and AI solutions for LEAs
        </Typography>
        <Typography variant="body1" style={{ lineHeight: '1.6', marginBottom: '10px' }}>
          <b>Project Concept</b><br/>
          Our project aims to gain a deeper understanding of the operational procedures involved in resolving crimes, particularly focusing on data-driven evidence processing. This includes investigating the methods, tools, and type of evidence data utilized.
        </Typography>
        <Typography variant="body1" style={{ lineHeight: '1.6', marginBottom: '10px' }}>
          With this objective in mind, we aim to develop cutting-edge data analytics and artificial intelligence solutions to address the challenges of crime resolution while adhering to the regulations set by the European Union and its Member States regarding the collection of evidence data.
        </Typography>
        <Typography variant="body1" style={{ lineHeight: '1.6', marginBottom: '10px' }}>
          To achieve this, we plan to employ advanced forms of network analytics that enable the collaborative processing of sensor data and assumptions about the individuals involved. For instance, we will analyze data from cameras, number plate recognition systems, face detection systems, non-content data from communications, and other relevant sources. By leveraging this information, we can deduce approximate behavioral patterns of the perpetrators, aiding in the identification of suspects. 
        </Typography>
        <Typography variant="body1" style={{ lineHeight: '1.6', marginBottom: '10px' }}>
          The main development and coordination is carried out by an SME, whereas a specialized law firm (also SME) focuses on related fundamental right challenges. A university specialized in police training coordinates the training process, whereas a leading AI research institute assures the scientific quality of the solution. An ESP is responsible to create pseudo operational data (anonymized datasets). The main pilot shall be executed by a highly experienced LEA with the support of a well renown research institute. Additional LEAs for the validation of the solution close the consortium partners. To measure the overall quality of the project a set of KPIs has been defined within the deliverables of each task/work package, meeting the requirements of the action.
        </Typography>
      </>
    ),
    link: 'https://www.tracy-project.eu/',
    linkLabel: 'Learn more',
  },
];

const Synergies = () => {
  return (
    <Container maxWidth="lg" style={{ marginTop: '100px' }}>
      <Box sx={{ mt: 4, mb: 4 }}>
        <CustomTypography variant="h3" text="Synergies" color="#0651A0" underline={true} />
        <Grid container spacing={4} style={{ marginTop: '40px' }}>
          {synergiesData.map((synergy, idx) => (
            synergy.combined ? (
              <Grid item xs={12} md={6} key={idx}>
                <Paper elevation={2} style={{ padding: '20px', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  {synergy.items.map((item, subIdx) => (
                    <Box key={subIdx} style={{ width: '100%', marginBottom: subIdx === synergy.items.length - 1 ? 0 : 32 }}>
                      <Box style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px', width: '100%' }}>
                        <img
                          src={item.image}
                          alt={item.title + ' image'}
                          style={{ maxWidth: '220px', maxHeight: '160px', width: '100%', height: 'auto', objectFit: 'contain' }}
                        />
                      </Box>
                      <Typography variant="h5" component="h2" style={{ marginBottom: '15px', color: '#0651A0', textAlign: 'center' }}>
                        {item.title}
                      </Typography>
                      <Box style={{ marginBottom: '15px', width: '100%' }}>
                        {item.description}
                      </Box>
                      {item.link && (
                        <MuiLink href={item.link} target="_blank" rel="noopener noreferrer" underline="hover" sx={{ fontWeight: 500 }}>
                          {item.linkLabel}
                        </MuiLink>
                      )}
                    </Box>
                  ))}
                </Paper>
              </Grid>
            ) : (
              <Grid item xs={12} md={6} key={idx}>
                <Paper elevation={2} style={{ padding: '20px', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <Box style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px', width: '100%' }}>
                    <img
                      src={synergy.image}
                      alt={synergy.title + ' image'}
                      style={{ maxWidth: '220px', maxHeight: '160px', width: '100%', height: 'auto', objectFit: 'contain' }}
                    />
                  </Box>
                  <Typography variant="h5" component="h2" style={{ marginBottom: '15px', color: '#0651A0', textAlign: 'center' }}>
                    {synergy.title}
                  </Typography>
                  <Box style={{ marginBottom: '15px', width: '100%' }}>
                    {synergy.description}
                  </Box>
                  {synergy.link && (
                    <MuiLink href={synergy.link} target="_blank" rel="noopener noreferrer" underline="hover" sx={{ fontWeight: 500 }}>
                      {synergy.linkLabel}
                    </MuiLink>
                  )}
                </Paper>
              </Grid>
            )
          ))}
        </Grid>
      </Box>
    </Container>
  );
};

export default Synergies; 